






















































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import ModalTabs from "../../DashboardLayoutComponents/ModalTabs.vue";
import FormField from "../../DashboardLayoutComponents/FormField.vue";

import unitModel from "@/models/unit.model";
import professionModel from "@/models/profession.model";
import specialtyModel from "@/models/specialty.model";
import sectorModel from "@/models/sector.model";
import userModel from "@/models/user.model";

@Component({
	components: { ModalTabs, FormField },
})
class UnitModal extends Vue {
	tabs = [
		{ icon: 'edit', name: 'Dados' },
		{ icon: 'account_balance', name: 'Administradora' },
		{ icon: 'dns', name: 'Especialidades' },
		{ icon: 'attach_money', name: 'Valores' },
		{ icon: 'delete', name: 'Excluir' },
	];
	schema: any = [];
	entity: any = { unitSectors: [] };
	serverEntityJson: string = "";
	loading = false;
	error = "";

	professionModel: any;
	specialtyModel: any;
	sectorModel: any;
	userModel: any;

	@Prop({ required: true })
	private unitId: any;

	constructor() {
		super();
		this.professionModel = professionModel;
		this.specialtyModel = specialtyModel;
		this.sectorModel = sectorModel;
		this.userModel = userModel;
	}

	private async mounted() {
		this.loading = true;
		try {
			this.schema = await unitModel.getDescription();
			await this.readEntity(this.unitId);
		} catch (error) {
			console.error(error);
		}
		this.loading = false;
	}

	updateNotes(notes: string) {
		this.entity.auditNotes = notes;
	}

	private async readEntity(id: number) {
		this.entity = Object.assign(await unitModel.read(id), {
			unitSectors: (await unitModel.read(id, "unitSectors", ["userSectors", "coordinatedSectors"])).unitSectors,
			priceTables: (await unitModel.read(id, "priceTables")).priceTables,
		});
		this.serverEntityJson = JSON.stringify(Object.assign({}, this.entity)); // copy entity to compare before update
	}

	async updateUnit() {
		try {
			const cleanedEntity = JSON.parse(JSON.stringify(this.entity));
			if (cleanedEntity.unitSectors) {
				cleanedEntity.unitSectors = cleanedEntity.unitSectors.map((us: any) => {
					if (us.coordinatorUser && us.coordinatorUser.id === null) {
						delete us.coordinatorUser;
					}
					return us;
				});
			}

			await unitModel.update(this.entity.id, cleanedEntity);
			await this.readEntity(this.entity.id);
			this.$toasted.success('Unidade atualizada');
			(this.$refs.unitModalTabs as ModalTabs).clearNotes();
		} catch (error) {
			console.error(error);
			this.$toasted.error((error as any).friendlyMessage || 'Não foi possível atualizar. Tente novamente.');
		}
		(this.$refs.unitModalTabs as ModalTabs).actionCompleted();
	}

	async deleteUnit() {
		if (!this.entity.deletionReason) {
			this.$toasted.error('Selecione uma justificativa para exclusão');
			(this.$refs.unitModalTabs as ModalTabs).actionCompleted();
			return;
		}

		try {
			await unitModel.delete(this.entity.id, `Justificativa: ${this.entity.deletionReason}\n${this.entity.auditNotes || ''}`);
			this.$toasted.success('Unidade excluída');
			this.$emit('close');
		} catch (error) {
			this.$toasted.error('Não foi possível excluir a unidade. Tente novamente.');
			(this.$refs.unitModalTabs as ModalTabs).actionCompleted();
		}
	}

	get enableAction() {
		return JSON.stringify(Object.assign({}, this.entity)) !== this.serverEntityJson;
	}

	getField(key: string) {
		return this.schema.find((prop: any) => prop.key === key) || {};
	}
}

export default UnitModal;
